/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCryptoLightningWithdrawalLimits} from '../api'

 export const useQueryGetCryptoLightningWithdrawalLimits = createReactQueryHook('getCryptoLightningWithdrawalLimits', getCryptoLightningWithdrawalLimits)
